import { ethers } from "ethers";

export const getRpcBalance = async (address: string): Promise<string> => {
  const rpcUrl = process.env.REACT_APP_RPC_URL || "https://rpc.xdcrpc.com";
  const provider = new ethers.JsonRpcProvider(rpcUrl);

  try {
    await provider.getBlockNumber();

    const response = await provider.getBalance(address);
    return response.toString();
  } catch (error) {
    console.error("Error in RPC or fetching balance:", error);
    return "0";
  }
};
